import { CompetitivenessLevel } from '@client/graphql/__generated__/types';

/**
 * Mapping of competitiveness levels without UNKNOWN to numeric values for sorting
 * Lower values = less competitive
 */
export const COMPETITIVENESS_ORDER: Record<CompetitivenessLevel, number> = {
  [CompetitivenessLevel.UNKNOWN]: 0,
  [CompetitivenessLevel.NOT_COMPETITIVE_AT_ALL]: 1,
  [CompetitivenessLevel.NOT_COMPETITIVE]: 2,
  [CompetitivenessLevel.COMPETITIVE]: 3,
  [CompetitivenessLevel.VERY_COMPETITIVE]: 4,
};

/**
 * Mapping of competitiveness levels to colors
 */
export const COMPETITION_COLORS: Record<CompetitivenessLevel, string> = {
  [CompetitivenessLevel.VERY_COMPETITIVE]: 'range.red',
  [CompetitivenessLevel.COMPETITIVE]: 'range.orange',
  [CompetitivenessLevel.NOT_COMPETITIVE]: 'range.yellow',
  [CompetitivenessLevel.NOT_COMPETITIVE_AT_ALL]: 'range.green',
  [CompetitivenessLevel.UNKNOWN]: 'range.gray',
};
